import { render, staticRenderFns } from "./WithholdingColumns.vue?vue&type=template&id=d3480b20&scoped=true"
import script from "./WithholdingColumns.vue?vue&type=script&lang=js"
export * from "./WithholdingColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3480b20",
  null
  
)

export default component.exports